import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/ocr-extract/page.tsx");
